module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-es-ES.6532bbe9.jpg";